import { render, staticRenderFns } from "./TownHall.vue?vue&type=template&id=5b31df8a&scoped=true"
import script from "./TownHall.vue?vue&type=script&lang=ts"
export * from "./TownHall.vue?vue&type=script&lang=ts"
import style0 from "./TownHall.vue?vue&type=style&index=0&id=5b31df8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31df8a",
  null
  
)

export default component.exports